import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { VerificationHeadingComponent } from '../verification-heading/verification-heading.component';
import { PrescriberMatchFormComponent } from '../prescriber-match-form/prescriber-match-form.component';

@Component({
    selector: 'app-validate-prescriber-match',
    templateUrl: './validate-prescriber-match.component.html',
    styleUrls: ['./validate-prescriber-match.component.scss'],
    imports: [VerificationHeadingComponent, PrescriberMatchFormComponent]
})
export class ValidatePrescriberMatchComponent {
  @Input() capture: Capture;
  @Input() patientAttachment: PatientAttachment;

  constructor() {}
}
